export default "__VITE_ASSET__YedTQA73__"